// extracted by mini-css-extract-plugin
module.exports = {"text":"quizPreview_text__2Iik9","btn":"quizPreview_btn__3ESMa"};